import { render, staticRenderFns } from "./DashboardFooter.vue?vue&type=template&id=d68ee5b4&"
var script = {}
import style0 from "./DashboardFooter.vue?vue&type=style&index=0&id=d68ee5b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports